interface GenerateBrandguideUrlOptions {
  slug: string;
  cname?: string | null;
  organizationKey?: string | null;
  v2?: boolean | null;
}

/**
 * Generate the correct Brandguide URL for either v1 or v2 Brandguides.
 * It requires the `BFG` window global being available.
 * 
 * @param options GenerateBrandguideUrlOptions
 * @returns string
 */
export const generateBrandguideUrl = (options: GenerateBrandguideUrlOptions): string => {
  const { cname, organizationKey, slug, v2 } = options;

  if (cname && !v2) {
    return `https://${cname}/${slug}`;
  } else if (v2) {
    return `${BFG.brandguideUrl}?redirect=${slug}${organizationKey ? `&org_key=${organizationKey}` : ''}`;
  } else {
    return `${BFG.brandguideV1Url}/${slug}`;
  }
};